import config from '../config';
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = config.api.API_URL + '/statistics';

export const statisticsService = {
  getAssetCount,
};

/**
 * Sends a GET request for how many assets of each kind the installation holds.
 *
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ asset_count: { system_count: number, datasource_count: number,
 *   dataset_count: number, field_count: number, glossary_count: number, entity_count: number,
 *   attribute_count: number } }>}
 */
function getAssetCount(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/asset_count`, requestOptions, signal).then(handleResponse);
}
